module.exports = __webpack_public_path__ + "static/media/ic-info-blue.321b0c62.svg";